// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkBox {
    width: 100%;
}

/*::ng-deep .mat-checkbox-checked .mat-checkbox-background {
    background-color: var(--primary-color) !important;
}*/

/*::ng-deep .mat-ripple-element {
    background-color: #C4DBEE !important;
    opacity: 0.4;
}*/

.p-field-checkbox, .p-field-radiobutton {
    display: flex;
    align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/app/appbuilder/controls/checkbox/checkbox.control.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;;EAEE;;AAEF;;;EAGE;;AAEF;IACI,aAAa;IACb,mBAAmB;AACvB","sourcesContent":[".checkBox {\n    width: 100%;\n}\n\n/*::ng-deep .mat-checkbox-checked .mat-checkbox-background {\n    background-color: var(--primary-color) !important;\n}*/\n\n/*::ng-deep .mat-ripple-element {\n    background-color: #C4DBEE !important;\n    opacity: 0.4;\n}*/\n\n.p-field-checkbox, .p-field-radiobutton {\n    display: flex;\n    align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
